import { Component, type ErrorInfo, type ReactNode } from 'react'

type ErrorBoundaryProps = {
  fallback: ReactNode
  onError: () => void
  children: ReactNode
}

type ErrorBoundaryState = { error: unknown }

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error("ErrorBoundary caught a render error:", error, info)
    this.props.onError()
  }

  render(): ReactNode {
    if (this.state.error !== null) return this.props.fallback
    return this.props.children
  }
}
